const DEFAULT_DT = "String";
const DATA_TYPES = [DEFAULT_DT, "Number", "Boolean", "Object"]

export {
    DEFAULT_DT,
    DATA_TYPES
};